
var jingdian = [
    // —————— 主城区（玄武、秦淮、鼓楼、建邺、栖霞、雨花台） ——————

    [118.861646, 32.060731, '中山陵'],
    [118.844474, 32.057733, '明孝陵'],
    [118.874300, 32.060967, '灵谷寺'],
    [118.861723, 32.060620, '音乐台'],
    [118.853133, 32.051186, '美龄宫'],
    [118.795268, 32.026998, '夫子庙'],
    [118.797057, 32.027359, '江南贡院'],
    [118.796010, 32.024914, '乌衣巷'],
    [118.794081, 32.017927, '老门东'],
    [118.789441, 32.015440, '大报恩寺遗址公园'],
    [118.791517, 32.027335, '瞻园'],
    [118.788053, 32.018436, '中华门瓮城'],
    [118.810163, 32.067517, '南京城墙（台城段）'],
    [118.803834, 32.050564, '总统府'],
    [118.831650, 32.046772, '南京博物院'],
    [118.748403, 32.041197, '侵华日军南京大屠杀遇难同胞纪念馆'],
    [118.801672, 32.067426, '鸡鸣寺'],
    [118.805436, 32.076613, '玄武湖公园'],
    [118.802866, 32.068908, '明城墙解放门'],
    [118.768430, 32.041142, '莫愁湖公园'],
    [118.754555, 32.100132, '阅江楼'],
    [118.776480, 32.069587, '颐和路公馆区'],
    [118.801065, 32.061071, '东南大学四牌楼校区'],
    [118.779954, 32.056819, '先锋书店（五台山总店）'],
    [118.750383, 32.109542, '下关火车主题公园'],
    [118.810657, 32.145636, '幕燕滨江风貌区'],
    [118.831634, 32.155283, '燕子矶公园'],

    // —————— 亲子 & 动物 & 乐园类（重点标注） ——————

    [118.809192, 32.097752, '红山森林动物园'],
    [118.807831, 32.099173, '红山森林动物园小熊猫馆'],
    [118.790178, 31.992333, '南京科技馆'],
    [118.718166, 31.805502, '银杏湖乐园'],
    [118.878804, 32.107024, '聚宝山公园（攀爬绳索乐园）'],
    [118.828687, 31.948698, '同曦恐龙主题乐园'],
    [118.672350, 31.980556, '鱼嘴湿地公园（含萌宠乐园）'],
    [118.716203, 32.025743, '中国绿化博览园'],
    [118.816645, 32.076174, '情侣园游乐场'],
    [118.744827, 31.994587, '河西天街溪谷乐园'],
    [118.628781, 32.067823, '凤凰山公园'],
    [118.728379, 31.803274, '野趣国际营地'],
    [118.781093, 31.755918, '漫森活自然教育营地'],

    // —————— 江宁区 ——————

    [118.750261, 31.911181, '牛首山文化旅游区'],
    [119.066297, 32.056761, '汤山温泉旅游度假区'],
    [119.010550, 32.069835, '阳山碑材'],
    [118.884145, 31.901584, '方山风景区'],
    [118.698967, 31.718217, '石塘竹海'],
    [118.696317, 31.786594, '黄龙岘茶文化村'],
    [118.727956, 31.905543, '金陵小城·燕集里'],
    [118.824429, 31.883466, '秣陵杏花村'],
    [118.843437, 31.875179, '上秦淮湿地公园'],

    // —————— 浦口区 ——————

    [118.667795, 32.132993, '珍珠泉风景区'],
    [118.608541, 32.105127, '老山国家森林公园'],
    [118.623347, 32.062036, '求雨山文化名人公园'],
    [118.650726, 32.119306, '四方艺术湖区'],
    [118.617435, 32.098439, '不老村'],
    [118.748268, 31.295201, '响堂村'],
    [118.597589, 32.160193, '西埂莲乡'],
    [118.602806, 32.127292, '水墨大埝'],
    [118.482314, 32.061060, '楚韵花香'],

    // —————— 六合区 ——————

    [118.994273, 32.482251, '金牛湖风景区'],
    [118.970568, 32.519683, '冶山国家矿山公园'],
    [118.590620, 32.576540, '止马岭生态保护区'],
    [118.854976, 32.465659, '平山森林公园'],
    [118.613257, 32.495826, '巴布洛生态谷'],
    [118.715902, 32.382500, '池杉湖湿地公园（苏皖交界）'],
    [118.941986, 32.466663, '桂子山石柱林'],

    // —————— 溧水区 ——————

    [119.032124, 31.606464, '无想山国家森林公园'],
    [118.993363, 31.651095, '天生桥风景区'],
    [119.036024, 31.570406, '傅家边农业科技园'],
    [118.907672, 31.538718, '石臼湖（天空之镜）'],
    [119.197739, 31.633499, '周园（私人博物馆群）'],
    [119.016976, 31.447286, '三叶梦华苑'],
    [119.126120, 31.702482, '大金山国防园'],
    [119.003045, 31.595116, '郭兴庄园'],

    // —————— 高淳区 ——————

    [118.876311, 31.324898, '高淳老街'],
    [119.020801, 31.355616, '游子山国家森林公园'],
    [118.901400, 31.296649, '固城湖水慢城'],
    [118.907971, 31.289102, '迎湖桃源'],
    [119.047533, 31.348554, '武家嘴热带风情谷'],
    [118.947538, 31.340749, '高淳陶瓷博物馆'],
    [118.860793, 31.367618, '薛城遗址'],
    [119.058913, 31.408607, '三条垄生态区'],
    [119.017173, 31.352966, '真如禅寺及祈福园']
];

var nanjing = [
    {
        name: '景点',
        group: 'base',
        list: jingdian,
        show: true,
        color: 'red'
    }
]


export default nanjing